import React, { useState } from "react";
import { supabase } from "../../supabase";
import "./AdminPanel.css";

function AdminPanel({ onLogout, onClose }) {
  const [url, setUrl] = useState("");
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!url.trim()) return;
    setLoading(true);
    setStatus(null);

    // 1. Llamar a la serverless function para obtener nombre, descripción y categoría
    let courseName = null;
    let name_en = null;
    let description = null;
    let description_en = null;
    let category = "Otros";
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (!session?.access_token) {
        setStatus({
          ok: false,
          msg: "Sesion expirada. Vuelve a iniciar sesion.",
        });
        setLoading(false);
        return;
      }

      const res = await fetch("/api/generate-description", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${session.access_token}`,
        },
        body: JSON.stringify({ url: url.trim() }),
      });
      const data = await res.json();
      console.log("API response:", res.status, data);
      if (res.ok) {
        courseName = data.courseName;
        name_en = data.name_en || null;
        description = data.description;
        description_en = data.description_en || null;
        category = data.category || "Otros";
      } else {
        console.error("API error:", data.error);
        setStatus({ ok: false, msg: `Error API: ${data.error}` });
        setLoading(false);
        return;
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setStatus({ ok: false, msg: `Error de conexión: ${err.message}` });
      setLoading(false);
      return;
    }

    // 2. Guardar en Supabase
    const { error } = await supabase.from("courses").insert({
      url: url.trim(),
      name: courseName,
      name_en,
      description,
      description_en,
      category,
    });

    if (error) {
      setStatus({ ok: false, msg: error.message });
    } else {
      setStatus({
        ok: true,
        msg: `Curso agregado ✅${courseName ? ` — ${courseName}` : ""}`,
      });
      setUrl("");
    }
    setLoading(false);
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    onLogout();
  };

  return (
    <div className="admin__overlay">
      <div className="admin__panel">
        <div className="admin__header">
          <h3>Admin Panel</h3>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <button className="admin__logout" onClick={handleLogout}>
              <i className="uil uil-sign-out-alt"></i> Logout
            </button>
            <button className="admin__logout" onClick={onClose}>
              <i className="uil uil-times"></i>
            </button>
          </div>
        </div>

        <form className="admin__form" onSubmit={handleAdd}>
          <label className="admin__label">URL del diploma (Platzi)</label>
          <input
            className="admin__input"
            type="url"
            placeholder="https://platzi.com/p/usuario/curso/..."
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            required
          />
          <button className="admin__btn" type="submit" disabled={loading}>
            {loading ? "Generando descripción..." : "Agregar curso"}
          </button>
        </form>

        {status && (
          <p className={status.ok ? "admin__success" : "admin__error"}>
            {status.msg}
          </p>
        )}

        <div className="admin__insights admin__insights--panel">
          <div className="admin__insights-header">
            <h4>Vercel Analytics</h4>
            <a
              href="https://vercel.com/dashboard"
              target="_blank"
              rel="noreferrer"
              className="admin__link"
            >
              Ver dashboard
            </a>
          </div>

          <p className="admin__insights-copy">
            Para saber si alguien entro en la pagina, revisa el panel de
            Analytics de Vercel. No hace falta guardar visitas en Supabase ni
            mantener una API adicional.
          </p>

          <div className="admin__insights-grid">
            <div className="admin__insight-card">
              <span className="admin__insight-label">Lo importante</span>
              <strong className="admin__insight-value">Visits</strong>
            </div>
            <div className="admin__insight-card">
              <span className="admin__insight-label">Confirmación</span>
              <strong className="admin__insight-value">Page views</strong>
            </div>
            <div className="admin__insight-card">
              <span className="admin__insight-label">Acceso</span>
              <strong className="admin__insight-value">
                Solo desde tu dashboard
              </strong>
            </div>
            <div className="admin__insight-card">
              <span className="admin__insight-label">Mantenimiento</span>
              <strong className="admin__insight-value">
                Cero complejidad extra
              </strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminPanel;
